import { ChevronLeft, ChevronRight } from "lucide-react";
import { monthLabel, shiftMonth } from "@/lib/format";

export function MonthPicker({ month, onChange }: { month: string; onChange: (m: string) => void }) {
  return (
    <div className="flex h-11 w-full items-center justify-between rounded-md border border-[#DDE1E8] bg-white px-1 sm:w-60" data-testid="month-picker">
      <button onClick={() => onChange(shiftMonth(month, -1))} className="rounded p-2 text-slate-500 hover:bg-slate-100" aria-label="Mes anterior" data-testid="month-prev-button"><ChevronLeft className="h-4 w-4" /></button>
      <span className="text-sm font-semibold capitalize text-[#1B2A4A]" data-testid="month-label">{monthLabel(month)}</span>
      <button onClick={() => onChange(shiftMonth(month, 1))} className="rounded p-2 text-slate-500 hover:bg-slate-100" aria-label="Mes siguiente" data-testid="month-next-button"><ChevronRight className="h-4 w-4" /></button>
    </div>
  );
}
